import type { MessageKey } from "@/i18n";

export type NavDef = {
  labelKey: MessageKey;
  path: string;
  icon:
    | "layout"
    | "brain"
    | "radar"
    | "search"
    | "key"
    | "newspaper"
    | "fileText"
    | "pen"
    | "share"
    | "megaphone"
    | "badge"
    | "image"
    | "video"
    | "youtube"
    | "globe"
    | "link"
    | "sparkles"
    | "chart"
    | "lightbulb"
    | "workflow"
    | "plug"
    | "activity"
    | "bell"
    | "settings"
    | "user"
    | "help";
  section: "main" | "create" | "optimize" | "system";
  /**
   * Optional brand artwork for items whose logo is not in the icon set (lucide ships
   * no YouTube mark). Rendered by the Sidebar from the shipped brand asset; every
   * other item keeps using `icon`.
   */
  brandIcon?: "youtube";
};

export const NAV_ITEMS: NavDef[] = [
  { labelKey: "nav.dashboard", path: "/", icon: "layout", section: "main" },
  { labelKey: "nav.businessIntelligence", path: "/business-intelligence", icon: "brain", section: "main" },
  { labelKey: "nav.competitorIntelligence", path: "/competitor-intelligence", icon: "radar", section: "main" },
  { labelKey: "nav.seo", path: "/seo", icon: "search", section: "main" },
  { labelKey: "nav.keywords", path: "/keyword-research", icon: "key", section: "main" },
  { labelKey: "nav.newsIntelligence", path: "/news-intelligence", icon: "newspaper", section: "main" },
  { labelKey: "nav.content", path: "/content-studio", icon: "pen", section: "create" },
  { labelKey: "nav.social", path: "/social-media", icon: "share", section: "create" },
  // YouTube is its own module (not part of Social Media) with its own routes.
  {
    labelKey: "nav.youtube",
    path: "/youtube",
    icon: "youtube",
    brandIcon: "youtube",
    section: "create",
  },
  { labelKey: "nav.imageStudio", path: "/image-studio", icon: "image", section: "create" },
  { labelKey: "nav.videoStudio", path: "/video-studio", icon: "video", section: "create" },
  { labelKey: "nav.backlinks", path: "/backlinks", icon: "link", section: "create" },
  { labelKey: "nav.analytics", path: "/analytics", icon: "chart", section: "optimize" },
  { labelKey: "nav.workflow", path: "/workflow", icon: "workflow", section: "optimize" },
  { labelKey: "nav.integrations", path: "/integrations", icon: "plug", section: "system" },
  { labelKey: "nav.notifications", path: "/notifications", icon: "bell", section: "system" },
  { labelKey: "nav.settings", path: "/settings", icon: "settings", section: "system" },
  { labelKey: "nav.profile", path: "/profile", icon: "user", section: "system" },
  { labelKey: "nav.help", path: "/help", icon: "help", section: "system" },
];

export const SECTION_LABEL_KEYS: Record<NavDef["section"], MessageKey> = {
  main: "sections.main",
  create: "sections.create",
  optimize: "sections.optimize",
  system: "sections.system",
};
